module.exports = ['$scope', 'sessionData', 'services', '$q', 'modal', '$state', 'employerUtility', 'storage',
    function($scope, sessionData, services, $q, modal, $state, employerUtility, storage) {
        //$scope.feedback = {};
        //setTimeout(function() {
        //    $scope.feedback.hideFeedback();
        //}, 300);

        //  $scope.stopEditSvcError = { svcFailed: false, errorMsg: '' };
        //if ($scope.stopEditSvcError.svcFailed == true) {
        //    setTimeout(function(){
        //        $scope.feedback.showFeedback($scope.stopEditSvcError.errorMsg, 'failure');
        //    }, 500);
        //}

    }];

